import { useState, useEffect } from "react";
import "./index.css";

function DarkModeToggle({ onToggle, defaultChecked }) {
  const [isDark, setIsDark] = useState(defaultChecked);

  useEffect(() => {
    setIsDark(defaultChecked);
  }, [defaultChecked]);

  return (
    <label className="switch">
      <input
        checked={isDark}
        onChange={(e) => {
          setIsDark(e.target.checked);
          onToggle?.(e.target.checked);
        }}
        type="checkbox"
      />
      <span className="slider">
        <span className="circle">
          <span className="shine shine-1"></span>
          <span className="shine shine-2"></span>
          <span className="shine shine-3"></span>
          <span className="shine shine-4"></span>
          <span className="shine shine-5"></span>
          <span className="shine shine-6"></span>
          <span className="shine shine-7"></span>
          <span className="shine shine-8"></span>
          <span className="moon"></span>
        </span>
      </span>
    </label>
  );
}
export default DarkModeToggle;
